import 'reflect-metadata';
(globalThis as any).global = globalThis;
